// src/pages/PlannerGatewayPage.js
import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';
import Login from '../opencomponents/LoginUser';
import PlannerPage from './plannercomponents/PlannerPage';
import PageShell from '../components/PageShell';

// 未登录时直接承载登录舞台（AuthStage 自带全屏背景）
const LoginContainer = styled.div`
    width: 100%;
    min-height: 100%;
`;

function PlannerGatewayPage() {
    // 从全局 AuthContext 中获取用户状态和登录成功的回调函数
    const { user, onLoginSuccess } = useAuth();

    // 如果用户已登录，直接渲染规划器主页面
    if (user) {
        return (
            <PageShell num="肆" title="計画" en="PLANNER" wide>
                <PlannerPage />
            </PageShell>
        );
    }

    // 如果用户未登录，渲染登录组件，并将 onLoginSuccess 作为 prop 传入
    // 这样登录成功后，AuthProvider 的状态会更新，此组件会重新渲染，并显示 PlannerPage
    return (
        <LoginContainer>
            <Login onLogin={onLoginSuccess} />
        </LoginContainer>
    );
}

export default PlannerGatewayPage;
